import { createSlice } from '@reduxjs/toolkit';
import { unique } from '@/src/tools/helper';

const defaultState = {
  searchList: [],
  nameSetting: [],
  draftNameSetting: [],
};

const SalesChannelVersionContentSlice = createSlice({
  name: 'SalesChannelVersionContent',
  initialState: defaultState,
  reducers: {
    searchList: (state, action) => {
      state.searchList.push(action.payload);
      state.searchList = unique(state.searchList); //去重
    },
    deleteSearch: (state, action) => {
      state.searchList.splice(action.payload, 1);
    },
  },
});

export const { searchList, deleteSearch } =
  SalesChannelVersionContentSlice.actions;

export default SalesChannelVersionContentSlice.reducer;
